import React, { useState, useEffect } from "react";
import ReactExport from "react-data-export";
import Styles from './Styles';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Download = props => {
    const [ dataSet, setDataSet ] = useState([{
        columns:[],
        data:[]
    }]);

    useEffect(() => {
        formatData();
    },[props.data])

    if (props.loading) {
        return null
    };

    const formatData = () => {
        let label;
        if (props.data.length > 0) {
            label = Object.keys(props.data[0]);
        } else {
            label = Object.keys([]);
        };
    
        const columns = label.reduce((r,i) => {
            r.push({
                title:i, 
                style:Styles.shippingDetailLabelStyle
            });
            return r;
        },[]);
    
        let totalItem = props.data.length;
        let totalPrice = 0; 
        let totalDiscount = 0; 
        let totalBasicPrice = 0;
        let style = Styles.shippingDetailRowLightStyle;
        const data = props.data.reduce((r,i,idx) => {
            let prevItem = idx === 0 ? props.data[0] : props.data[idx-1]
            let currentItem = props.data[idx];
      
            if (idx === 0) {
                totalPrice =  currentItem.price;
                totalDiscount =  currentItem.discount_price;
                totalBasicPrice =  currentItem.basic_price;
            };
    
            if (prevItem.order_id === currentItem.order_id) {
                style = style
            } else {
                totalPrice = totalPrice + currentItem.price;
                totalDiscount = totalDiscount + currentItem.discount_price;
                totalBasicPrice = totalBasicPrice + currentItem.basic_price;
                style = style === Styles.shippingDetailRowLightStyle ? Styles.shippingDetailRowDarkStyle : Styles.shippingDetailRowLightStyle;
            };
    
            r.push([
                {value:i.order_id || "",style},
                {value:i.waybill_id || "",style},
                {value:i.shipper_name || "",style},
                {value:i.shipper_organization || "",style},
                {value:i.origin_name || "",style},
                {value:i.origin_address || "",style},
                {value:i.destination_name || "",style},
                {value:i.destination_address || "",style},
                {value:i.destination_note || "",style},
                {value:i.note || "",style},
                {value:i.item_name || "",style},
                {value:i.item_price || "",style},
                {value:i.item_dimension || "",style},
                {value:i.item_weight || "",style},
                {value:i.courier_company || "",style},
                {value:i.courier_service || "",style},
                {value:i.delivery_time || "",style},
                {value:i.quantity || "",style},
                {value:i.basic_price || "",style},
                {value:i.discount_percentage+`%`,style},
                {value:i.discount_price || "",style},
                {value:i.price || "",style},
            ]);
    
    
    
            if (idx+1 === totalItem) {
                style = Styles.shippingDetailRowLightStyle;
                r.push([
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"",style},
                    {value:"Total", style:Styles.fontBoldCell},
                    {value:totalBasicPrice, style:Styles.fontBoldCell},
                    {value:"-", style:Styles.fontBoldCell},
                    {value:totalDiscount, style:Styles.fontBoldCell},
                    {value:totalPrice, style:Styles.fontBoldCell},
                ]);
            } 
            return r;
        },[])
        setDataSet([{
            columns,
            data
        }])
    }

    return (
        <div className={props.className}>
            <ExcelFile filename={props.filename} element={<button className={`btn btn-primary btn-block ${props.buttonClassName}`}>{props.title}</button>}>
                <ExcelSheet dataSet={dataSet} name="Shipping Details"/>
            </ExcelFile>
        </div>
    );
}

export default Download;